import React from 'react';
import process from 'process';
window.process = process;
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx'
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

// 🔥 MOSTRA LOADER SUBITO (prima di qualsiasi controllo)
function showLoader() {
    const loader = document.getElementById('update-loader');
    if (loader) {
        loader.style.display = 'flex';
    }
}

// 🔥 NASCONDI LOADER
function hideLoader() {
    const loader = document.getElementById('update-loader');
    if (loader) {
        loader.style.display = 'none';
    }
}

// 🔥 CONTROLLO COMPLETO - Blocca tutto fino a conferma
async function ensureLatestVersion() {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
        // Dev mode o browser senza SW → procedi normalmente
        renderApp();
        return;
    }

    try {
        console.log('🔒 Verifica versione in corso...');
        showLoader(); // Mostra loader SUBITO

        const reg = await navigator.serviceWorker.getRegistration();

        if (!reg) {
            console.log('⚠️ Nessun SW registrato, prima installazione');
            hideLoader();
            renderApp();
            return;
        }

        // CASO 1: C'è già un SW in waiting → attivalo SUBITO
        if (reg.waiting) {
            console.log('🚀 SW in waiting rilevato - attivazione forzata...');

            reg.waiting.postMessage({ type: 'SKIP_WAITING' });

            // Aspetta attivazione
            await new Promise((resolve) => {
                const timeout = setTimeout(resolve, 3000); // Max 3 secondi

                reg.waiting.addEventListener('statechange', (e) => {
                    if (e.target.state === 'activated') {
                        clearTimeout(timeout);
                        resolve();
                    }
                });
            });

            console.log('🔄 Reload per applicare nuova versione...');
            window.location.reload();
            return; // Non procedere, stiamo ricaricando
        }

        // CASO 2: Controlla se c'è un update disponibile
        console.log('🔍 Controllo aggiornamenti disponibili...');
        await reg.update();

        // Aspetta 2 secondi per vedere se arriva un nuovo SW
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Ricontrolla se ora c'è un waiting
        if (reg.waiting) {
            console.log('🆕 Nuovo SW scaricato - attivazione...');

            reg.waiting.postMessage({ type: 'SKIP_WAITING' });

            await new Promise((resolve) => {
                const timeout = setTimeout(resolve, 3000);

                reg.waiting.addEventListener('statechange', (e) => {
                    if (e.target.state === 'activated') {
                        clearTimeout(timeout);
                        resolve();
                    }
                });
            });

            console.log('🔄 Reload con nuova versione...');
            window.location.reload();
            return;
        }

        // CASO 3: Nessun update, procedi con versione attuale
        console.log('✅ Versione corrente, nessun update');
        hideLoader();
        renderApp();

    } catch (error) {
        console.error('❌ Errore verifica versione:', error);
        // In caso di errore, procedi comunque
        hideLoader();
        renderApp();
    }
}

// 🎨 Funzione di render separata
function renderApp() {
    console.log('🎨 Rendering app...');
    hideLoader(); // Assicurati che loader sia nascosto

    root.render(<App />);

    if (process.env.NODE_ENV === 'production') {
        // Service Worker con auto-update
        serviceWorkerRegistration.register({
            onUpdate: (registration) => {
                console.log('🆕 Nuova versione rilevata durante uso!');

                if (registration && registration.waiting) {
                    showLoader();

                    registration.waiting.postMessage({ type: 'SKIP_WAITING' });

                    registration.waiting.addEventListener('statechange', (e) => {
                        if (e.target.state === 'activated') {
                            console.log('🔄 Ricarico con nuova versione...');
                            window.location.reload();
                        }
                    });
                }
            },
            onSuccess: () => {
                console.log('✅ Service Worker pronto');
            }
        });
    } else {
        console.log('🔧 Dev mode: Service Worker disabilitato');
        serviceWorkerRegistration.unregister();
    }
}

// 🚀 AVVIA con verifica BLOCCANTE
ensureLatestVersion();

// Controllo aggiornamenti quando app torna visibile
document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState === 'visible' && process.env.NODE_ENV === 'production') {
        const reg = await navigator.serviceWorker?.getRegistration();
        if (reg) {
            console.log('🔍 App tornata visibile - controllo update...');
            await reg.update();

            await new Promise(resolve => setTimeout(resolve, 1000));

            if (reg.waiting) {
                console.log('✅ Update pronto - attivazione...');
                showLoader();

                reg.waiting.postMessage({ type: 'SKIP_WAITING' });

                reg.waiting.addEventListener('statechange', (e) => {
                    if (e.target.state === 'activated') {
                        window.location.reload();
                    }
                });
            }
        }
    }
});
